import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdLiveHelp } from "react-icons/md";
import JoditEditor from "jodit-react";
import { Button, Container, Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import SearchableDropdown from "../shared/SearchableDropdown";
import SearchableDropdownMulti from "../shared/SearchableDropdownMulti";
//import BhinaMeetingCalendarModal from "../bhinameeting/BhinaMeetingCalendarModal";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";
import { Row, Col, Card } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  mkhTypeOptions,
  addVisible,
  setAddVisible,
  setAdded,
}) {
  const { showHelp, setShowHelp, perek, setPerek, saeef, setSaeef } =
    useContext(HelpContext);
  const history = useNavigate();
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const [adding, setAdding] = useState(false);
  const editor1 = useRef(null);
  const editor2 = useRef(null);
  const editor3 = useRef(null);
  const editor4 = useRef(null);
  const editor5 = useRef(null);
  const editorPrefix = useRef(null);
  const editorSuffix = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false, // Keeps all toolbar options visible
      // System fonts will be used without listing them
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );
  const [hagashaFocus, setHagashaFocus] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const [inputField, setInputField] = useState({
    mkh_num: "",
    title: "",
    mkh_type: "O",
    canceled: false,
    yeood_mesra: "",
    mesrot_num: 1,
    ahoz_mesra: 100.0,
    persom_date: "",
    hagsha_date: "",
    dirog: "",
    reshom_plili: false,
    ekary_tafkid: "",
    haskala: "",
    nesion_mektsoey: "",
    nesion_neholy: "",
    drishot_nosafot: "",
    prefix: "",
    suffix: "",
    department: null,
    mayor: null,
    job: null,
    kfifoot: null,
    ptor_reason: null,
  });
  const [departments, setDepartments] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [mayor, setMayor] = useState();
  //const [kfifoot, setKfifoot] = useState([]);
  const [ptorReasons, setPtorRreasons] = useState([]);
  const [jobValue, setJobValue] = useState("");
  const [kfifootValue, setKfifootValue] = useState("");

  const handleChange = (e) => {
    const { name, type } = e.target;
    if (type == "checkbox") {
      const { checked } = e.target;
      const checkedValue = checked ? 1 : 0;
      setInputField((prevState) => ({
        ...prevState,
        [name]: checkedValue,
      }));
    } else {
      const { value } = e.target;
      setInputField((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setInputField((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleChangeSDD = (id, val) => {
    setInputField((prevState) => ({
      ...prevState,
      job: id,
    }));
  };

  const handleChangeJob = (id) => {
    setInputField((prevState) => ({
      ...prevState,
      job: id,
    }));
  };

  const handleChangeKfifoot = (id) => {
    setInputField((prevState) => ({
      ...prevState,
      kfifoot: id,
    }));
  };
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getDepartments = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "department/", {
          signal: controller.signal,
        });
        isMounted && setDepartments(response.data);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    const getPtorReasons = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "ptorreason/", {
          signal: controller.signal,
        });
        isMounted && setPtorRreasons(response.data);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    const getJobs = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "jobslist/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setJobs(response.data);
        }
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    const getMayor = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "lastmayor/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setMayor(response.data);
          if (response.data.length !== 0) {
            setInputField((prevState) => ({
              ...prevState,
              ["mayor"]: response.data.id,
            }));
          } else {
            alert("חייבים לעדכן את שם ראש הרשות בטבלאות");
          }
        }
      } catch (err) {
        console.error(err);
        alert("כנראה שלא הוגדר ראש רשות בטבלאות");
      }
    };
    const getGenParams = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "genparams/", {
          signal: controller.signal,
        });
        isMounted &&
          setInputField((prevState) => ({
            ...prevState,
            ["prefix"]: response.data[0].mkh_prefix,
            ["suffix"]: response.data[0].mkh_suffix,
          }));
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getDepartments();
    getJobs();
    getPtorReasons();
    getMayor();
    getGenParams();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const postData = async () => {
      setAdding(true);

      try {
        const response = await axiosPrivate.post(
          baseURL + "mekhraz/",
          inputField,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          SetIsAdded(true);
          setAdded((prevCount) => prevCount + 1);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert("בעיה בהוספת המכרז");
        }
      }
    };
    if (inputField.mkh_type == "פטור" && inputField.ptor_reason == "") {
      alert("חובה לציין את סיבת הפטור.");
    } else {
      postData();
      setError(false);
      setAddVisible(false);
      setAdding(false);
    }
  };
  // render

  if (!addVisible) return;
  if (adding) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <HelpModal />
        {mayor ? (
          <Card className="success container px-5" bg="light">
            <Card.Header className="mx-auto">
              <center>
                <h3
                  onClick={() => {
                    setSaeef("2-3");
                    setShowHelp(true);
                  }}
                >
                  הוספת מכרז חדש
                  <span className="help">
                    <MdLiveHelp />
                  </span>
                </h3>

                <p
                  onClick={() => {
                    setSaeef("1004");
                    setShowHelp(true);
                  }}
                >
                  ניתן להוסיף מכרז חדש ע"י העתקת מכרז קיים
                  <span className="help">
                    <MdLiveHelp />
                  </span>
                </p>
                <Button variant="danger" onClick={() => setAddVisible(false)}>
                  ביטול הוספה
                </Button>
              </center>
            </Card.Header>
            <Card.Body>
              <form onSubmit={handleSubmit}>
                <Container className="col-sm-10">
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="canceled">האם המכרז בוטל?</label>
                        <br />
                        <input
                          type="checkbox"
                          id="canceled"
                          name="canceled"
                          checked={inputField.canceled}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group col-sm-6">
                        <label htmlFor="text1" className="required-label">
                          מספר המכרז:
                        </label>
                        <input
                          type="text"
                          name="mkh_num"
                          value={inputField.mkh_num}
                          onChange={handleChange}
                          className="form-control"
                          id="text1"
                          placeholder="כמו 01/2022"
                          required
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="title" className="required-label">
                          תאור:
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={inputField.title}
                          onChange={handleChange}
                          className="form-control"
                          id="title"
                          placeholder="הקלד תאור למכרז"
                          required
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="department" className="required-label">
                          מחלקה:
                        </label>
                        <br />
                        <select
                          name="department"
                          onChange={handleDDSChange}
                          value={inputField.department}
                          required
                        >
                          <option value="" selected>
                            בחר מחלקה
                          </option>
                          {departments?.map((d) => (
                            <option key={d.id} value={d.id}>
                              {d.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="yeood_mesra">ייעוד משרה:</label>
                        <input
                          type="text"
                          name="yeood_mesra"
                          value={inputField.yeood_mesra}
                          onChange={handleChange}
                          className="form-control"
                          id="yeood_mesra"
                          placeholder="הקלד ייעוד משרה"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="jobs">תפקיד:</label>
                        <br />

                        <SearchableDropdownMulti
                          options={jobs}
                          label="jobtype_title"
                          label2="title"
                          label3="ignore"
                          id="id"
                          other="title "
                          selectedVal={jobValue}
                          handleChange={(val, id) => {
                            setJobValue(val);
                            //setUserEmail(email);
                            handleChangeSDD(id, val);
                          }}
                          inputProps={{ autocomplete: "off" }}
                        />
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="kfifoot">כפיפות ל:</label>
                        <br />
                        <SearchableDropdown
                          options={jobs}
                          label="title"
                          id="id"
                          other="title"
                          selectedVal={kfifootValue}
                          handleChange={(val, id) => {
                            setKfifootValue(val);
                            handleChangeKfifoot(id);
                          }}
                          inputProps={{ autocomplete: "off" }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label className="required-label">סוג המכרז:</label>
                        <br />
                        <select
                          name="mkh_type"
                          onChange={handleChange}
                          value={inputField.mkh_type}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר סוג
                          </option>
                          {mkhTypeOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="ptor_reason">סיבת הפטור:</label>
                        <br />
                        <select
                          name="ptor_reason"
                          onChange={handleDDSChange}
                          value={inputField.ptor_reason}
                          className="wide-select"
                        >
                          <option value="" selected>
                            אין פטור
                          </option>
                          {ptorReasons?.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="mesrot_num" className="required-label">
                          מספר המשרות המוצעות:
                        </label>
                        <input
                          type="number"
                          name="mesrot_num"
                          value={inputField.mesrot_num}
                          onChange={handleChange}
                          className="form-control"
                          id="mesrot_num"
                          placeholder="מספר המשרות המוצעות"
                          required
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="ahoz_mesra" className="required-label">
                          אחוז כל משרה בממוצע:
                        </label>
                        <input
                          type="number"
                          name="ahoz_mesra"
                          value={inputField.ahoz_mesra}
                          onChange={handleChange}
                          className="form-control"
                          id="ahoz_mesra"
                          placeholder="50"
                          required
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="persom_date" className="required-label">
                          תאריך פרסום:
                        </label>
                        <input
                          type="date"
                          name="persom_date"
                          value={inputField.persom_date}
                          onChange={handleChange}
                          className="form-control"
                          id="persom_date"
                          placeholder="תאריך הפרסום בעיתונות"
                          required
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="hagsha_date">תאריך הגשה אחרון:</label>
                        <label
                          onClick={() => {
                            setPerek("התקופה להגשת הבקשות");
                            setSaeef("5");
                            setShowHelp(true);
                          }}
                          htmlFor="hagsha_date"
                          className="required-label"
                        >
                          תאריך הגשה אחרון:
                          <span className="help">
                            <MdLiveHelp />
                          </span>
                        </label>

                        <input
                          type="date"
                          name="hagsha_date"
                          value={inputField.hagsha_date}
                          onChange={handleChange}
                          className="form-control"
                          id="hagsha_date"
                          placeholder="30-11-2022"
                          onFocus={() => setHagashaFocus(true)}
                          onBlur={() => setHagashaFocus(false)}
                          required
                        />
                        <p
                          id="uidnote"
                          className={hagashaFocus ? "instructions" : "hide"}
                        >
                          {" "}
                          במכרז פומבי ייקבע פרק זמן להגשת בקשות להשתתף במכרז
                          לתקופה שלא תהיה קצרה מארבעה עשר ימים ולא תהיה ארוכה
                          מארבעים ושנים יום
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="dirog" className="required-label">
                          דירוג:
                        </label>
                        <input
                          type="text"
                          name="dirog"
                          value={inputField.dirog}
                          onChange={handleChange}
                          className="form-control"
                          id="dirog"
                          placeholder="כמו: מחר 39-41"
                          required
                        />
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="reshom_plili">
                          תצהיר בדבר היעדר הרשעות פליליות?
                        </label>
                        <br />
                        <input
                          type="checkbox"
                          id="reshom_plili"
                          name="reshom_plili"
                          checked={inputField.reshom_plili}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <br></br>
                      <label htmlFor="prefix">
                        רישא-תופיע אחרי שם ומספר המכרז-
                      </label>
                      <JoditEditor
                        editorRef={editorPrefix}
                        name="prefix"
                        tabIndex={1}
                        value={inputField.prefix}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            prefix: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <br></br>
                      <label htmlFor="ekary_tafkid">עיקרי התפקיד</label>
                      <JoditEditor
                        editorRef={editor1}
                        name="ekary_tafkid"
                        tabIndex={2}
                        value={inputField.ekary_tafkid}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            ekary_tafkid: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="haskala">דרישות השכלה</label>
                      <JoditEditor
                        editorRef={editor2}
                        tabIndex={3}
                        name="haskala"
                        value={inputField.haskala}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            haskala: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="nesion_mektsoey">
                        דרישות נסיון מקצועי
                      </label>
                      <JoditEditor
                        editorRef={editor3}
                        tabIndex={4}
                        name="nesion_mektsoey"
                        value={inputField.nesion_mektsoey}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            nesion_mektsoey: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <label htmlFor="nesion_neholy">דרישות נסיון ניהולי</label>
                      <JoditEditor
                        editorRef={editor4}
                        tabIndex={5}
                        name="nesion_neholy"
                        value={inputField.nesion_neholy}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            nesion_neholy: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="drishot_nosafot">דרישות נוספות</label>
                      <JoditEditor
                        editorRef={editor5}
                        tabIndex={6}
                        name="drishot_nosafot"
                        value={inputField.drishot_nosafot}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            drishot_nosafot: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <br></br>
                      <label htmlFor="suffix">
                        סיפא-תופיע לפני הצגת שם החתום על המכרז-
                      </label>
                      <JoditEditor
                        editorRef={editorSuffix}
                        name="suffix"
                        tabIndex={7}
                        value={inputField.suffix}
                        config={config}
                        onBlur={(newContent) => {
                          setInputField((prevState) => ({
                            ...prevState,
                            suffix: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                  <br></br>
                  <button type="submit" className="btn btn-primary">
                    שמור
                  </button>
                </Container>
              </form>
            </Card.Body>
          </Card>
        ) : (
          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
              color: "white",
              fontSize: "22px",
            }}
          >
            לא ניתן להוסיף מכרז!
          </p>
        )}
      </>
    );
  }
}
